import { Component, HostBinding, Input, OnInit, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { getLorenzFormLayoutEnumString, LibFormValidityDotComponent, LorenzFormComponentDisplayOptions, LorenzFormControl, LorenzFormLayoutEnum } from '@lib/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'lib-form-control-html',
	templateUrl: './lib-form-control-html.component.html',
	imports: [ReactiveFormsModule, LibFormValidityDotComponent, TranslateModule],
	styleUrl: './lib-form-control-html.component.scss'
})
export class LibFormControlHtmlComponent implements OnInit {
	@Input({ required: true, alias: 'control' }) lorenzFormControl!: LorenzFormControl;

	@Input({ required: false, alias: 'options' }) lorenzFormComponentDisplayOptions: LorenzFormComponentDisplayOptions = {};

	@HostBinding('attr.class') hostCssClass = '';

	formGroup!: FormGroup;

	computedValue = signal<any | null>(null);

	title = signal<string | null>(null);

	ngOnInit() {
		this.formGroup = this.lorenzFormControl.parent as FormGroup;

		this.lorenzFormControl.payload.displayOptions = this.lorenzFormComponentDisplayOptions;

		// prettier-ignore
		this.hostCssClass = [
				this.lorenzFormControl.getKey(),
				getLorenzFormLayoutEnumString(this.lorenzFormComponentDisplayOptions?.layout ?? null)
			].join(' ');

		this.updateValueAndTitle(this.lorenzFormControl.getInnerHTML());

		this.lorenzFormControl.valueChanges.subscribe((value) => {
			this.updateValueAndTitle(this.lorenzFormControl.getInnerHTML());
		});
	}

	get isLayoutFloatingLabels(): boolean {
		return this.lorenzFormComponentDisplayOptions?.layout === LorenzFormLayoutEnum.FLOATING_LABELS;
	}

	private updateValueAndTitle(value: any): void {
		if (this.lorenzFormControl?.payload?.titleFunction instanceof Function) {
			this.title.set(this.lorenzFormControl.payload.titleFunction(value));
		}

		if (this.lorenzFormControl.payload && typeof this.lorenzFormControl.payload.innerHTML === 'function') {
			this.computedValue.set(this.lorenzFormControl.payload.innerHTML(value));
		} else {
			this.computedValue.set(value);
		}
	}
}
